import { render, staticRenderFns } from "./RevaluationQuotas.vue?vue&type=template&id=275652f2&scoped=true"
import script from "./RevaluationQuotas.vue?vue&type=script&lang=ts"
export * from "./RevaluationQuotas.vue?vue&type=script&lang=ts"
import style0 from "./RevaluationQuotas.vue?vue&type=style&index=0&id=275652f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275652f2",
  null
  
)

export default component.exports